import Controller from "./loadingSpinner.controller";
import template from "./loadingSpinner.html";

const loadingSpinner = {
  template,
  controller: Controller,
  bindings: {
    hasLoadingText: "<",
    text: "@",
  },
};

export default loadingSpinner;



// WEBPACK FOOTER //
// ./src/components/loadingSpinner/loadingSpinner.component.js